export enum Banner {
  Signature = "SIG",
  Warehouse = "ECO",
  Store = "TAN",
};